// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGThumbIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGThumbIcon extends PureComponent<
  ISVGThumbIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        visibility="visible"
        width="10px"
        height="13px"
        viewBox="0 0 10 13"
        enableBackground="new 0 0 10 13"
      >
        <g>
          <title>background</title>
          <rect
            fill="#ffffff00"
            id="canvas_background"
            height="15"
            width="12"
            y="-1"
            x="-1"
          />
        </g>
        <g>
          <title>Layer 1</title>
          <path
            stroke="#ffffff00"
            id="svg_4"
            d="m-0.56391,7.9518l5.7596,5.7324l6.49155,-7.43126c11.11659,7.6611 -0.14017,-5.97506 -0.26892,-8.65546l-12.93914,0.18276l0.54214,7.51955z"
            fill="#8594b1"
          />
        </g>
      </svg>
    );
  }
}
